// import React from 'react';
// import promoImage from '../assets/Promo.png';

// function CategoryFilter() {
//   return (
//     <div className="w-full max-w-xs p-4 bg-white border-r border-gray-200">

//       {/* Search Bar */}
//       <div className="mb-6">
//         <input
//           type="text"
//           placeholder="Search"
//           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-400"
//         />
//       </div>


//       <div className="mb-6">
//         <h2 className="text-lg font-semibold mb-3 ">Categories</h2>
//         <ul className="space-y-2 border border-gray-300">
//           <li className=" border-gray-300">
//             <a href="#" className="block px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100">Travel</a>
//           </li>
//           <li className="border-t border-gray-300">
//             <a href="#" className="block px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100">Bike Rental</a>
//           </li>
//           <li className="border-t border-gray-300">
//             <a href="#" className="block px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100">Tips</a>
//           </li>
//         </ul>
//       </div>


//       {/* Recent Posts */}
//       <div className="mb-6">
//         <h2 className="text-lg font-semibold mb-3">Recent Posts</h2>
//         <ul className="space-y-2 text-gray-700">
//           <li><a href="#" className="hover:underline">Top 5 Scenic Road Trips from Chennai to Coastal Getaways</a></li>
//           <li><a href="#" className="hover:underline">How to Plan a Road Trip from Bangalore to Ooty: Route and Tips</a></li>
//           <li><a href="#" className="hover:underline">Solo Women Travel: Safe and Scenic Routes in South India</a></li>
//           <li><a href="#" className="hover:underline">Tips for Renting a Car During Monsoon: Stay Safe on the Road</a></li>
//         </ul>
//       </div>

//       {/* Promotional Image with Download Button */}
//       <div className="text-center mt-6">
//         <img src={promoImage} alt="Promo" className="w-full rounded-lg mb-4" />
//         <button className="px-6 py-2 bg-[#FF9630] text-white rounded-full font-semibold hover:bg-orange-600">Download App</button>
//       </div>
//     </div>
//   );
// }

// export default CategoryFilter;



import React from 'react';
import { AiOutlineSearch } from 'react-icons/ai'; // Import search icon
import promoImage from '../assets/Promo.png';

function CategoryFilter() {
  return (
    <div className="w-full bg-white">

      {/* Search Bar */}
      <div className="mb-6 relative  bg-gray-200 p-1">
        <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
          <AiOutlineSearch /> {/* Search Icon */}
        </span>
        <input
          type="text"
          placeholder="Search"
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:border-blue-400 text-gray-700"
        />
      </div>

      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-3 ">Categories</h2>
        <ul className="space-y-2 border border-gray-300">
          <li className=" border-gray-300">
            <a href="#" className="block px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100">Travel</a>
          </li>
          <li className="border-t border-gray-300">
            <a href="#" className="block px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100">Bike Rental</a>
          </li>
          <li className="border-t border-gray-300">
            <a href="#" className="block px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100">Tips</a>
          </li>
        </ul>
      </div>

      {/* Recent Posts */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-3 text-left">Recent Posts</h2>
        <ul className="space-y-2 text-gray-700 text-left leading-8 ">
          <li><a href="#" className="hover:underline">Top 5 Scenic Road Trips from Chennai to Coastal Getaways</a></li>
          <li><a href="#" className="hover:underline">How to Plan a Road Trip from Bangalore to Ooty: Route and Tips</a></li>
          <li><a href="#" className="hover:underline">Solo Women Travel: Safe and Scenic Routes in South India</a></li>
          <li><a href="#" className="hover:underline">Tips for Renting a Car During Monsoon: Stay Safe on the Road</a></li>
        </ul>
      </div>

      {/* Promotional Image with Download Button */}
      <div className="text-center mt-6 border bg-gray-300 p-16">
        <img src={promoImage} alt="Promo" className="w-full rounded-lg mb-4" />
        <button className="px-6 py-2 bg-[#FF9630] text-white rounded-full font-semibold hover:bg-orange-600">Download App</button>
      </div>
    </div>
  );
}

export default CategoryFilter;




